export const parseReactQuillText = (string) => {
    let newString = string;

    newString = newString.replaceAll(
        "<li>",
        "<li style='list-style: disc; margin-left:20px; color:#060606;'>",
    );

    newString = newString.replaceAll(
        /<a([^>]*)href="([^"]*)"([^>]*)>/g,
        `<a$1href="$2"$3 target="_blank" style="color: #0f6fcf; text-decoration: underline;">`,
    );

    return newString;
};
